import { guard } from "effector";
import { audioEnded } from "frontend/src/domain/audio";
import { $playerHasNextTrack } from "frontend/src/domain/player-track-queue";
import { $isTimetableInterruptionPlaying } from "frontend/src/features/play-timetable-interruptions";
import { pause } from "frontend/src/features/control-audio";
guard({
    clock: audioEnded,
    source: {
        playerHasNextTrack: $playerHasNextTrack,
        isTimetableInterruptionPlaying: $isTimetableInterruptionPlaying,
    },
    filter: function (_a) {
        var playerHasNextTrack = _a.playerHasNextTrack, isTimetableInterruptionPlaying = _a.isTimetableInterruptionPlaying;
        return !playerHasNextTrack && !isTimetableInterruptionPlaying;
    },
    target: pause,
});
